import React, { Component } from 'react';
import { Row, Nav, Tab } from 'react-bootstrap';
import ServicesList from './ServicesList';
import FilterResultsButton from '../Filter/FilterResultsButton';
import ResetFilters from '../Filter/ResetFilters';
import FilteredServices from './FilteredServices';
import ServicesOptions from './ServicesOptions';
import ServiceBenefitsTab from './ServiceBenefitsTab';
import ServiceAvailabilityTab from './ServiceAvailabilityTab'
import MediaQuery from 'react-responsive';
import FilterMobileTab from '../MobileView/FilterMobileTab';
import FilterOptions from '../MobileView/FilterOptions';
import FilterFooter from '../Filter/FilterFooter';
import LoaderImg from '../../images/ajax_loader.gif';
import { headingRef } from '../../utils/spaConstants';




class ServicesFilter extends Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedKey: 'services'
        }
        this.onBenefitSelect = this.onBenefitSelect.bind(this);
    }

    componentDidMount() {
        this.setState({ selectedKey: 'services' });
        this.props.actions.showFilteredServices(false);
    }
    getIcon(tabName) {
        let selectedKey = (this.props.services.showFilteredServices) ? '' : this.state.selectedKey;
        return (tabName !== selectedKey) ? (
            <svg aria-label="open menu" focusable="false" data-test-id="link-down-arrow" className="svg-icon svg-icon-down-arrow">
                <use xlinkHref="#icon-down-arrow"></use></svg>)
            : <svg aria-label="close menu" focusable="false" className="svg-icon svg-icon-close-x">
                <use xlinkHref="#icon-close-x" data-test-id="link-close-arrow" ></use></svg>;
    }

    resetFilter(type, actions) {
        this.props.actions.resetFilter(type);
    }

    onBenefitSelect(benefit) {
        this.props.actions.filterByBenfit(benefit);
    }

    onTabClick(selectedKey, trigger) {
        let _selectedKey;
        let currentKey = (this.props.services.showFilteredServices) ? '' : this.state.selectedKey;
        if (currentKey === selectedKey) {
            _selectedKey = '';
        } else {
            _selectedKey = selectedKey;
            this.props.actions.showFilteredServices(false);
        }
        window.scrollTo(0, 0);
        if (trigger === 'footer') {
            //alert('done'+ headingRef[selectedKey]);
            let focusRef = document.getElementById('focus-ref');
            focusRef.setAttribute('tabindex', '-1');
            focusRef.focus();
        }
        this.setState({ selectedKey: _selectedKey });
    }

    setTabIndex() {
        let navItemList = document.getElementsByClassName('filter-nav-items-link');
        navItemList && navItemList.forEach((element) => {
            element.tabIndex = '0';
        });
    }

      updateSelectedKey = (_selectedKey) => {
              this.setState({ selectedKey: _selectedKey });
          };

    render() {
        let selectedKey = (this.props.services.showFilteredServices) ? '' : this.state.selectedKey;
        let { services = {} } = this.props;
        let { availableServices, isServicesLoading, filter } = services;
        let count = 0;
        let hideReset = (!filter.selectedGuest && !filter.selectedCategory && !filter.selectedDate && !filter.selectedBenefit)
        if (availableServices)
            count = availableServices.length;
        //this.setTabIndex();

        return (
            <>
                <Tab.Container id="left-tabs-example" activeKey={this.state.selectedKey} defaultActiveKey={selectedKey} onSelect={this.onTabClick.bind(this)}>
                    <MediaQuery minWidth={768}>
                        {(matches) => {
                            if (matches)
                                return (
                                    <nav aria-label="Spa search filters" id='spa-filter-navigation' className="spa-filter-nav-container headline-gray-e6-bg">

                                        <Nav as='div' role="tablist" className="spa-filter-nav container" defaultActiveKey="services">
                                            <Nav.Item onClick={this.onTabClick.bind(this, 'services')} role="tab" aria-selected={selectedKey === 'services'} as='button' className={`col-md-3 font-size-p4 gotham-xn-book title-hover ${selectedKey === 'services' ? 'active-item' : ''}`}>
                                                <span className='filter-nav-items-link' eventKey="services" data-test-id="services-nav">Services   {this.getIcon('services')}</span>
                                            </Nav.Item>
                                            <Nav.Item onClick={this.onTabClick.bind(this, 'availability')} role="tab" aria-selected={selectedKey === 'availability'} as='button' className={`col-md-3 font-size-p4 gotham-xn-book title-hover ${selectedKey === 'availability' ? 'active-item' : ''}`}>
                                                <span className='filter-nav-items-link' eventKey="availability" data-test-id="availability-nav" >Availability   {this.getIcon('availability')}</span>
                                            </Nav.Item>
                                            <Nav.Item onClick={this.onTabClick.bind(this, 'benefits')} role="tab" as='button' aria-selected={selectedKey === 'benefits'} className={`col-md-3 font-size-p4 gotham-xn-book title-hover ${selectedKey === 'benefits' ? 'active-item' : ''}`}>
                                                <span className='filter-nav-items-link' eventKey="benefits" data-test-id="benefits-nav">Benefits   {this.getIcon('benefits')}</span>
                                            </Nav.Item>
                                            <span className='visuallyhidden' role='status'>{`${count} Results Found`}</span>

                                            {(selectedKey) ?
                                                <li className='filter-button-container padding-5 col-md-3'>
                                                    <FilterResultsButton isServicesLoading={isServicesLoading} onClick={this.props.onFilterButtonClick} count={count} />
                                                </li> :
                                                (isServicesLoading) ?
                                                    <div className='spa-loading-text-container'>
                                                        <img alt='Loader-spinner' width='20px' height='20px' src={LoaderImg} /><span className='services-loading-text font-size-p5 gotham-xn-book'>Loading</span></div> :
                                                    <li className='col-md-3 filtered-count-container'>
                                                        <h2 className='filtered-count spa-treatments-heading font-size-p4 gotham-xn-book' data-test-id="spa-treatments-heading">
                                                            {`${count} Results`}
                                                        </h2>
                                                        {!hideReset &&

                                                            <div className='banner-text filtered-reset font-size-p1 gotham-xn-medium' data-test-id="reset-button" onClick={this.resetFilter.bind(this, 'All')}>
                                                                <svg focusable="false" className="svg-icon svg-icon-refresh"> <use xlinkHref="#icon-refresh" data-test-id="reset-button-undo" ></use></svg> Reset Filters </div>
                                                        }
                                                    </li>
                                            }
                                        </Nav>
                                    </nav>
                                )
                            else
                                return (<Row>
                                    <div className="spa-filter-nav-container headline-gray-e6-bg">
                                        <Nav className="spa-filter-nav font-size-p2 gotham-xn-medium" defaultActiveKey="services">
                                            <Nav.Item className={`col-md-6 col-sm-6 col-xs-6 ${selectedKey === 'services' ? 'active-item' : ''}`}>
                                                <Nav.Link eventKey="services">Filters   {this.getIcon('services')}</Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item className={`col-md-6 col-sm-6 col-xs-6 ${selectedKey === 'options' ? 'active-item' : ''}`}>
                                                <Nav.Link eventKey="options"  >Options   {this.getIcon('options')}</Nav.Link>
                                            </Nav.Item>
                                        </Nav>
                                    </div>
                                    {(selectedKey) ?
                                        null :
                                        (isServicesLoading) ?
                                            <div className='spa-loading-text-container'><img alt='Loader-spinner' width='15px' height='15px' src={LoaderImg} /><span className='services-loading-text'>Loading</span></div> :
                                            <div className='col-md-3 filtered-count-container spa-padding-result-count'>
                                                <h2 className='filtered-count font-size-p5 gotham-xn-medium  spa-left' data-test-id="spa-treatments-heading">
                                                    {`${count} Results`}
                                                </h2>
                                                <div className='banner-text filtered-reset font-size-p1 gotham-xn-medium spa-right' onClick={this.resetFilter.bind(this, 'All')}>
                                                    <svg role="img" focusable="false" className="svg-icon svg-icon-refresh"> <use xlinkHref="#icon-refresh"></use></svg> Reset Filters </div>
                                            </div>

                                    }
                                </Row>)
                        }}

                    </MediaQuery>
                    {(selectedKey) ?
                        <>

                            <Tab.Content style={{ paddingBottom: '53px' }} as='section' className='filter-tab-content container m-auto'>
                                <span id='focus-ref' className='visuallyHidden' aria-label={`${selectedKey} open menu`} ></span>
                                <MediaQuery minWidth={768}>
                                    {(matches) => (matches) ?
                                        <ResetFilters actions={this.props.actions} services={this.props.services} /> : null
                                    }
                                </MediaQuery>
                                <MediaQuery minWidth={768}>
                                     {(matches) => (matches) ?
                                <>
                                 <Tab.Pane eventKey="services">
                                    <ServicesList {...this.props} ></ServicesList>
                                 </Tab.Pane>
                                 <Tab.Pane eventKey="availability">
                                    <ServiceAvailabilityTab actions={this.props.actions} services={this.props.services}></ServiceAvailabilityTab>
                                 </Tab.Pane>
                                 <Tab.Pane eventKey="benefits">
                                    <ServiceBenefitsTab onBenefitSelect={this.onBenefitSelect} {...this.props}></ServiceBenefitsTab>
                                 </Tab.Pane>
                                </> :
                                <>
                                 <FilterMobileTab hideReset={hideReset} resetFilter={this.resetFilter.bind(this, 'All')} onBenefitSelect={this.onBenefitSelect.bind(this)} updateSelectedKey = {this.updateSelectedKey.bind(this)} selectedKey={selectedKey} {...this.props}/>
                                </>
                                }
                                </MediaQuery>
                                <Tab.Pane eventKey="options">
                                    <FilterOptions hideReset={hideReset} count={count} onFilterButtonClick={this.props.onFilterButtonClick} isServicesLoading={services.isServicesLoading} resetFilter={this.resetFilter.bind(this, 'All')} onBenefitSelect={this.onBenefitSelect.bind(this)} actions={this.props.actions} services={this.props.services}></FilterOptions>
                                </Tab.Pane>
                            </Tab.Content>
                            <MediaQuery minWidth={576}>
                                <FilterFooter selectedKey={this.state.selectedKey} onTabClick={this.onTabClick.bind(this)} isServicesLoading={services.isServicesLoading} actions={this.props.actions} services={services} onFilterButtonClick={this.props.onFilterButtonClick} />
                            </MediaQuery>
                        </> :
                        <MediaQuery minWidth={576}>
                            {(matches) => {
                                if (matches)
                                    return (<>
                                        <ServicesOptions actions={this.props.actions} services={this.props.services} />
                                        <FilteredServices isMobileView={!matches} {...this.props} />
                                    </>)
                                else
                                    return (<FilteredServices isMobileView={!matches} {...this.props} />)
                            }}
                        </MediaQuery>
                    }

                </Tab.Container>
            </>

        )
    }
}

export default ServicesFilter;